import { TableCells } from 'models';

export const investorSpaceAddonTableCells: TableCells[] = [
  {
    id: 'Cooperative.Name',
    logicalName: 'uds_cooperativeid',
    label: '#portal.investor.space.cooperative',
    type: 'string',
  },
  {
    id: 'Name',
    logicalName: 'uds_name',
    label: '#portal.investor.space.name',
    type: 'string',
  },
  {
    id: 'Status.Label',
    logicalName: 'uds_spacestatuscode',
    label: '#portal.investor.space.status',
    type: 'string',
  },
];
